import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export const ADMIN_SHELL_FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold/35 focus-visible:ring-offset-2 focus-visible:ring-offset-bg-tertiary'

export const ADMIN_SHELL_GOLD_CTA =
  'bg-brand-gold-dim border border-brand-gold-glow text-brand-gold'

type AdminPageFrameProps = {
  title: string
  subtitle?: ReactNode
  icon?: ReactNode
  actions?: ReactNode
  customHeader?: ReactNode
  children: ReactNode
  className?: string
  headerClassName?: string
  titleClassName?: string
  bodyClassName?: string
}

export default function AdminPageFrame({
  title,
  subtitle,
  icon,
  actions,
  customHeader,
  children,
  className,
  headerClassName,
  titleClassName,
  bodyClassName,
}: AdminPageFrameProps) {
  return (
    <div
      className={cn(
        'flex h-full min-h-0 flex-col overflow-hidden bg-bg-tertiary text-text-primary',
        className
      )}
    >
      {customHeader ? (
        customHeader
      ) : (
        <header
          className={cn(
            'h-14 flex shrink-0 items-center justify-between gap-4 border-b border-border bg-surface px-4 sm:px-6',
            headerClassName
          )}
        >
          <div className="flex min-w-0 items-center gap-4">
            {icon ? <span className="flex-shrink-0 text-origin-blue">{icon}</span> : null}
            <h1
              className={cn('text-sm font-semibold text-text-primary font-display', titleClassName)}
            >
              {title}
            </h1>
            {subtitle ? (
              <span className="min-w-0 truncate text-xs text-text-secondary">{subtitle}</span>
            ) : null}
          </div>
          {actions ? (
            <div className="flex items-center justify-end gap-2 flex-wrap">{actions}</div>
          ) : null}
        </header>
      )}

      <div
        className={cn('flex-1 min-h-0 overflow-y-auto bg-bg-tertiary p-4 sm:p-6', bodyClassName)}
      >
        {children}
      </div>
    </div>
  )
}
